export const SECURE_BACKEND_CONFIG = {
		SERVER_URL		: 'https://beta-new-backend.flyingresearch.net/',
		HTTP_SECURITY	: {
			TIME_TOKEN		: false,
			ENCRYPTION		: false
		},
		TIME_TOKEN			: {
			TIME_WINDOW		: 60,
			SALT    		: 'R93Yvjg3TpCAQ5Rh'
		},
		ENCRYPTION_SECRET	: '',
		GOOGLE_RECAPTCHA_KEY: ''
	};
